import React from 'react'
import { CheckIcon } from '@heroicons/react/24/solid'
import { useHistory } from '../../contexts/HistoryContext'

const SubmittedMessage = ({
  message = 'Action',
  buttonMessage = 'Go to Dashboard',
  redirectPath = '/',
  showIcon = true,
}) => {
  const { goBackOrHome } = useHistory()

  const handleRedirect = () => {
    goBackOrHome(redirectPath)
  }

  return (
    <div className="relative bg-background rounded-lg shadow-md p-6 pt-[140px] flex flex-col items-center text-center max-w-[400px] mx-auto">
      {showIcon && (
        <div className="absolute top-[36px] w-[94px] h-[94px] rounded-full bg-success-500 flex items-center justify-center">
          <CheckIcon className="w-12 h-12 text-white" />
        </div>
      )}
      <h2 className="font-bold text-[19.2px] leading-[23px] capitalize text-black mb-2">
        {message} successfully
      </h2>
      <p className="font-normal text-[13.5px] leading-[16px] text-black/70 mb-8 max-w-[327px]">
        {message} successfully! 🎉
      </p>
      <button
        onClick={handleRedirect}
        className="w-full h-[55px] flex justify-center items-center rounded-[10px] bg-gradient-to-r from-secondary-700 to-secondary-500 shadow-md text-white text-lg font-medium capitalize hover:opacity-90 transition-opacity"
      >
        {buttonMessage}
      </button>
    </div>
  )
}

export default SubmittedMessage
